<script lang="ts">
	export let title: string;
	export let description: string;
	export let index: number;
</script>

<div class="flex flex-col border border-black max-w-[250px] min-w-[250px] min-h-[250px] bg-white">
	<div class="flex flex-row border-b border-b-black">
		<div class="flex flex-col justify-end bg-black text-5xl text-white min-w-[58px] min-h-[71px]">
			<div class="self-end select-none {index === 0 ? 'pr-2' : ''} -mb-2.5">
				{index + 1}
			</div>
		</div>
		<div class="text-xl self-center pl-2">{title}</div>
	</div>
	<div class="p-4">{description}</div>
</div>
